import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { ObjectDetailsScreenValidationResult } from '../../../../../../../@types/validation-types'
import { Stepper } from '../../../../../../common/inputs/stepper/Stepper'

const MaxRentalTime: React.FC<FieldProps<ObjectDetailsScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <Stepper
        id='max-rental-time'
        propertyName='maxRentalTime'
        label={t('wizard.screen.objectDetails.maxRentalTime')}
        placeholder={t('wizard.screen.objectDetails.placeholder.months')}
        input={insertionData.maxRentalTime}
        type='tel'
        min={0}
        max={999}
        step={1}
        errors={validationMessages?.maxRentalTime ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default MaxRentalTime
